import { CT } from "../../../consts";

const showConditionsEvent = [
  {
    field: "eventDetailsShowShareOptions",
    value: 1,
    defaultValue: 1,
  },
];

const showConditionsCalendar = [
  {
    field: "calendarShowShare",
    value: 1,
    defaultValue: 0,
  },
];

const showConditionsCalendarOrEvent = [
  ...showConditionsEvent,
  {
    field: "calendarShowShare",
    value: 1,
    defaultValue: 0,
    or: true,
  },
];

showConditionsCalendarOrEvent[1].or = true;

export const definitions = {
  title: <span>Sharing</span>,
  icon: "share",
  groups: [
    {
      label: "Share calendar button",
      options: [
        {
          title: "Show share button",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            // CT.bubble,
          ],
          applicable: "design",
          name: "calendarShowShare",
          defaultValue: 0,
          tooltip: {
            url: "http://help.display.church/en/articles/9203820-display-church-design-sharing-show-share-button-for-entire-calendar",
            message: "Toggle on or off the calendar share button",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Share button",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
          ],
          name: "calendarShare",
          defaultValue: {
            bg: "#D3D3D3",
            bgHover: "#d3d3d3",
            borderRadius: "10px",
            padding: "0em 0.6em 0em 0.6em",
          },
          style: {
            selector: [".dc-calendar-share-button"],
          },
          show: [showConditionsCalendar],
          control: {
            kind: "surface",
            options: {
              showBg: true,
              showBgHover: true,
              showPadding: true,
              showMargin: true,
              showBorderStyle: true,
              showBorderWidth: true,
              showBorderColor: true,
              showBorderRadius: true,
            },
          },
        },
        {
          title: "Share button",
          templates: [CT.detailedList],
          name: "calendarShare",
          defaultValue: {
            bg: "#fff",
            bgHover: "#edf2f7",
            borderRadius: "18px",
            padding: "0.6666em 1em 0.6666em 1em",
          },
          style: {
            selector: [".dc-detailed-list--calendar-share-button"],
          },
          show: [showConditionsCalendar],
          control: {
            kind: "surface",
            options: {
              showBg: true,
              showBgHover: true,
              showPadding: true,
              showMargin: true,
              showBorderStyle: true,
              showBorderWidth: true,
              showBorderColor: true,
              showBorderRadius: true,
            },
          },
        },

        {
          title: "Share button label",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.bubble,
          ],
          name: "calendarShareTypography",
          defaultValue: {
            fontSize: "14px",
            fontWeight: "400",
            color: "#333",
            colorHover: "#fff",
          },
          style: {
            selector: [".dc-calendar-share-button"],
          },
          show: [showConditionsCalendar],
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },
        {
          title: "Share button label",
          templates: [CT.detailedList],
          name: "calendarShareTypography",
          defaultValue: {
            fontSize: "0.7em",
            fontWeight: "400",
            lineHeight: "1.3em",
            color: "#2d3748",
            colorHover: "#2d3748",
          },
          style: {
            selector: [".dc-detailed-list--calendar-share-button"],
          },
          show: [showConditionsCalendar],
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showLineHeight: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },
      ],
    },
    {
      label: "Share event",
      options: [
        {
          title: "Show share options in event details",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsShowShareOptions",
          defaultValue: 1,
          show: [{}],
          tooltip: {
            url: "https://help.display.church/en/articles/4616046-design-events-show-share-options",
            message: "Display sharing options for individual events",
          },
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Share Button",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsShare",
          defaultValue: {
            bg: "#00aafb",
            bgHover: "#00AAFBB3",
            borderRadius: "25px",
            padding: "0.3em 1.4em 0.3em 1.4em",
          },
          style: {
            selector: [".event-row--details .share-event.share-event--link"],
          },
          show: showConditionsEvent,
          control: {
            kind: "surface",
            options: {
              showBg: true,
              showBgHover: true,
              showPadding: true,
              showMargin: true,
              showBorderStyle: true,
              showBorderWidth: true,
              showBorderColor: true,
              showBorderRadius: true,
            },
          },
        },

        {
          title: "Share button label",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.bubble,
            CT.detailedList,
          ],
          name: "eventDetailsShareTypography",
          defaultValue: {
            fontSize: "1em",
            fontWeight: "500",
            color: "#fff",
            colorHover: "#fff",
            letterSpacing: 0,
            textTransform: "uppercase",
          },
          style: {
            selector: [".event-row--details .share-event.share-event--link"],
          },
          show: [showConditionsCalendar],
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showColor: true,
              showColorHover: true,
              showLetterSpacing: true,
              showTextTransform: true,
            },
          },
        },
      ],
    },
    {
      label: "Popup design",
      options: [
        {
          title: "Background color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "sharePopupBgColor",
          defaultValue: "#fff",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: [".dc-share-popup--card"],
            property: "background-color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Card title color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "sharePopupTitleColor",
          defaultValue: "#000",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: [".dc-share-popup--card-section--header"],
            property: "color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Source color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "sharePopupSourceColor",
          defaultValue: "#000",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: ".dc-share-popup--card-section--subheader",
            property: "color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Separator color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "sharePopupSeparatorColor",
          defaultValue: "#e0e0e0",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: ".dc-share-popup--card-section",
            property: "border-color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Close button color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "sharePopupCloseButtonColor",
          defaultValue: "#333",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: [
              ".dc-share-popup--card--close::before",
              ".dc-share-popup--card--close::after",
            ],
            property: "background-color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Close button color on hover",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "sharePopupCloseButtonColorOnHover",
          defaultValue: "#333",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: [
              ".dc-share-popup--card--close:hover::before",
              ".dc-share-popup--card--close:hover::after",
            ],
            property: "background-color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
      ],
    },
    {
      label: "QR Code",
      options: [
        {
          title: "Show QR code",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "popupQrCode",
          defaultValue: 1,
          show: showConditionsCalendarOrEvent,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "QR code background color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "qrCodeBgColor",
          defaultValue: "#fff",
          show: [
            ...showConditionsCalendarOrEvent,
            {
              field: "popupQrCode",
              value: 1,
              defaultValue: 1,
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "QR code foreground color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "qrCodeFgColor",
          defaultValue: "#000",
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
          show: [
            ...showConditionsCalendarOrEvent,
            {
              field: "popupQrCode",
              value: 1,
              defaultValue: 1,
            },
          ],
        },
        {
          title: "QR code border color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "qrCodeBorderColor",
          defaultValue: "#e0e0e0",
          style: {
            selector: ".dc-share-popup--card-section--qr svg",
            property: "border-color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
          show: [
            ...showConditionsCalendarOrEvent,
            {
              field: "popupQrCode",
              value: 1,
              defaultValue: 1,
            },
          ],
        },
      ],
    },
    {
      label: "Social buttons",
      options: [
        {
          title: "Show share on facebook",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
          ],
          name: "shareFacebookShow",
          defaultValue: 1,
          show: showConditionsCalendarOrEvent,
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Show share on X",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
          ],
          name: "shareXButtonShow",
          defaultValue: 1,
          show: showConditionsCalendarOrEvent,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
      ],
    },
    {
      label: "Shareable URL",
      options: [
        {
          title: "Show share link",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "popupShareLink",
          defaultValue: 1,
          show: showConditionsCalendarOrEvent,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Link background color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "popupLinkBgColor",
          defaultValue: "#fff",
          style: {
            selector: ".dc-share-popup--link-input",
            property: "background-color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
          show: [
            ...showConditionsCalendarOrEvent,
            {
              field: "popupShareLink",
              value: 1,
              defaultValue: 1,
            },
          ],
        },
        {
          title: "Link color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "popupLinkColor",
          defaultValue: "#000",
          style: {
            selector: ".dc-share-popup--link-input_value",
            property: "color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
          show: [
            ...showConditionsCalendarOrEvent,
            {
              field: "popupShareLink",
              value: 1,
              defaultValue: 1,
            },
          ],
        },
        {
          title: "Link border color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "popupLinkBorderColor",
          defaultValue: "#e0e0e0",
          style: {
            selector: ".dc-share-popup--link-input",
            property: "border-color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
          show: [
            ...showConditionsCalendarOrEvent,
            {
              field: "popupShareLink",
              value: 1,
              defaultValue: 1,
            },
          ],
        },
        {
          title: "Copy button color",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "popupCopyButtonColor",
          defaultValue: "#2646CB",
          style: {
            selector: ".dc-share-popup--link-input_button",
            property: "background-color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
          show: [
            ...showConditionsCalendarOrEvent,
            {
              field: "popupShareLink",
              value: 1,
              defaultValue: 1,
            },
          ],
        },
        {
          title: "Copy button color on hover",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
            CT.bubble,
          ],
          name: "popupCopyButtonColorOnHover",
          defaultValue: "#1a2f8c",
          style: {
            selector: ".dc-share-popup--link-input_button:hover",
            property: "background-color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
          show: [
            ...showConditionsCalendarOrEvent,
            {
              field: "popupShareLink",
              value: 1,
              defaultValue: 1,
            },
          ],
        },
      ],
    },
  ],
};
